import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectCurrentUser } from "../../../auth/authSlice";
import Questions from "./index";
import NewQuestion from "./NewQuestion";
import EditQuestion from "./EditQuestion";
import BulkQuestion from "./BulkQuestion";
import AIQuestion from "./AIQuestion";

const QuestionsRouter = () => {
  const user = useSelector(selectCurrentUser);
  const userRoles = user?.roles?.map((r) => r?.role?.name).filter(Boolean) || [];
  const isAdmin = userRoles.includes("admin") && !userRoles.includes("teacher");

  return (
    <Routes>
      <Route index element={<Questions />} />
      <Route path="new" element={isAdmin ? <Navigate to="." replace /> : <NewQuestion />} />
      <Route path="ai" element={isAdmin ? <Navigate to="." replace /> : <AIQuestion />} />
      <Route path="edit/:id" element={isAdmin ? <Navigate to="." replace /> : <EditQuestion />} />
      <Route path="bulk" element={isAdmin ? <Navigate to="." replace /> : <BulkQuestion />} />
    </Routes>
  );
};

export default QuestionsRouter;
